import React from 'react';

interface SmallTagProps {
  children: React.ReactNode;
  className?: string;
}

export const SmallTag: React.FC<SmallTagProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={`flex items-center text-14 sm:text-16 font-semibold bg-[#57534E] text-white px-[8px] py-[4px] rounded-[1000px] ${className}`}
    >
      {children}
    </div>
  );
};

export default SmallTag; 